var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReward = function SvgReward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0B753E",
    clipPath: "url(#reward_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.127 13.078c.394 0 .592 0 .771.066l.074.03c.174.08.313.22.592.498.64.642.961.962 1.356.992q.08.006.16 0c.394-.03.715-.35 1.356-.992.278-.278.418-.418.592-.497q.036-.017.073-.03c.18-.067.377-.067.77-.067h.073c1.006 0 1.508 0 1.82-.313.313-.312.313-.815.313-1.82v-.073c0-.394 0-.59.067-.77q.014-.038.03-.074c.08-.174.22-.313.498-.592.641-.641.962-.962.991-1.356a1 1 0 0 0 0-.16c-.03-.394-.35-.715-.991-1.356-.279-.279-.418-.418-.498-.592l-.03-.074c-.067-.179-.067-.376-.067-.77v-.073c0-1.005 0-1.508-.312-1.82s-.815-.312-1.82-.312h-.073c-.394 0-.591 0-.77-.067q-.039-.014-.074-.03c-.174-.08-.314-.22-.592-.498-.641-.641-.962-.962-1.357-.992a1 1 0 0 0-.159 0c-.395.03-.715.35-1.356.992-.279.279-.418.418-.592.498l-.074.03c-.18.067-.377.067-.77.067h-.073c-1.005 0-1.508 0-1.82.312s-.313.815-.313 1.82v.073c0 .394 0 .591-.066.77l-.03.074c-.08.174-.22.313-.499.592-.64.641-.961.962-.991 1.356a1 1 0 0 0 0 .16c.03.394.35.715.991 1.356.28.279.418.418.498.592q.016.036.03.074c.067.18.067.376.067.77v.073c0 1.005 0 1.508.313 1.82.312.313.815.313 1.82.313z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10 6-4 4"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M10 10h-.007M6.007 6H6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "reward_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgReward;